import styled from 'styled-components';

export const HeaderKeywordMonitoringStyled = styled.div`
  display: flex;
  flex-direction: column;

  .container-full {
    display: flex;
    flex-direction: column;
    margin: 0;
    border-radius: 0.5rem;
    border: 1px solid #efefef;
    background: #ffffff;
  }

  .task-summary-wrapper {
    height: 5rem !important;
    min-height: 5rem !important;
    align-items: center;
    padding: 2rem 1.5rem;

    .task-summary-photo {
      height: 3rem;
    }
    .task-summary-logo {
      height: 3rem !important;
      width: 3rem !important;
    }
    .hover-gray:hover {
      background-color: #f6f6f6;
      cursor: pointer;
    }
  }

  .task-summary-wrapper[data-open='true'] {
    border-radius: 0.5rem 0.5rem 0 0;
  }

  .task-summary-wrapper[data-open='false'] {
    border-radius: 0.5rem 0.5rem 0.5rem 0.5rem;
  }
`;
